import {BaseTerms} from "../../infrastructure/models/base-terms";

export class PredictionsWidgetTerms extends BaseTerms {}
